import { courseContextSearchParams } from './course-admin-navigation.ts';
import { libraryContextSearchParams } from './library-navigation.ts';

export function quizAttemptHref(
  attemptId: string,
  assessmentId: string,
  searchParams: URLSearchParams,
): string {
  const query = libraryContextSearchParams(searchParams);
  query.set('assessment_id', assessmentId);
  return `/evaluaciones/intentos/${attemptId}?${query.toString()}`;
}

export function quizAttemptBack(
  searchParams: URLSearchParams,
  assessmentId?: string | null,
): { to: string; label: string } {
  const resolvedAssessmentId = searchParams.get('assessment_id') || assessmentId;
  if (resolvedAssessmentId) {
    const query = libraryContextSearchParams(searchParams);
    const qs = query.toString();
    return {
      to: `/evaluaciones/${resolvedAssessmentId}${qs ? `?${qs}` : ''}`,
      label: 'Volver a la evaluación',
    };
  }

  const courseId = searchParams.get('course_id');
  const itemId = searchParams.get('item_id');
  if (courseId && itemId) {
    const query = courseContextSearchParams(searchParams);
    const qs = query.toString();
    return {
      to: `/courses/${courseId}/play/${itemId}${qs ? `?${qs}` : ''}`,
      label: 'Volver al curso',
    };
  }

  return { to: '/evaluaciones', label: 'Volver a evaluaciones' };
}
